module.exports = __webpack_public_path__ + "img/indicators-banner@2x.6b9fb22f.png";